import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { FormControl, Select, MenuItem } from '@mui/material'
import { selectLocale, setLanguage } from 'store/locale/slice'
import { FiFlag, SvFlag, EnFlag } from 'assets/images'

export const flag = (code: string): string => {
  switch (code) {
    case 'fi':
      return FiFlag
    case 'en':
      return EnFlag
    case 'sv':
      return SvFlag
    default:
      return ''
  }
}

export default function LanguageSwitcher(): JSX.Element {
  const locale = useSelector(selectLocale)
  const dispatch = useDispatch()

  const changeLanguage = (event: any) => {
    const language = locale.availableLanguages.find(({ code }) => code === event.target.value)?.code || 'en'
    dispatch(setLanguage(language))
  }

  return (
    <FormControl>
      <FlagSelect
        value={locale.language.code}
        onChange={changeLanguage}
        sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { border: 0 } }}
      >
        {locale.availableLanguages.map((language: Language, index: number) => {
          return (
            <MenuItem key={index} value={language.code}>
              <FlagImage src={flag(language.code)} />
            </MenuItem>
          )
        })}
      </FlagSelect>
    </FormControl>
  )
}

const FlagSelect = styled(Select)`
  margin-right: 20px;
  boxshadow: none;
  & > .MuiSelect-select {
    padding-right: 0;
  }
  & > .MuiSelect-icon {
    display: none;
  }
`

const FlagImage = styled.img`
  width: 30px;
  height: auto;
  padding: 5px;
`
